import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['deselectAllButton', 'selectAllButton']

  deselectAll() {
    this.element.querySelectorAll('input[type=checkbox]').forEach(input => (input.checked = false))
    this.displaySelectAllButton()
  }

  selectAll() {
    this.element.querySelectorAll('input[type=checkbox]').forEach(input => (input.checked = true))
    this.displayDeselectAllButton()
  }

  manageSelectButton() {
    const anyInputChecked = this.element.querySelectorAll('input[type=checkbox]:checked').length > 0

    if (anyInputChecked) {
      this.displayDeselectAllButton()
    } else {
      this.displaySelectAllButton()
    }
  }

  displaySelectAllButton() {
    this.hide(this.deselectAllButtonTarget)
    this.display(this.selectAllButtonTarget)
  }

  displayDeselectAllButton() {
    this.hide(this.selectAllButtonTarget)
    this.display(this.deselectAllButtonTarget)
  }

  display(button) {
    button.classList.remove('hidden')
  }

  hide(button) {
    button.classList.add('hidden')
  }
}
